if (!customElements.get('bitig-bundle')) {
  customElements.define('bitig-bundle', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.ready || !this.querySelector('form')) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.dialog = this.querySelector('dialog');
        this.strings = JSON.parse(this.querySelector('[data-bundle-strings]').textContent);
        this.options = this.querySelector('[data-bundle-options]');
        this.search = this.querySelector('[data-bundle-search]');
        this.status = this.querySelector('[data-bundle-status]');
        this.addEventListener('change', (event) => { if (event.target.matches('[data-bundle-check]')) this.update(); });
        this.addEventListener('click', (event) => {
          const change = event.target.closest('[data-bundle-change]');
          if (change) this.openPicker(change);
          if (event.target.closest('[data-bundle-close]')) this.dialog.close();
          if (event.target.closest('[data-bundle-retry]')) this.loadBooks();
          const option = event.target.closest('[data-bundle-option]');
          if (option && !option.disabled) this.choose(option);
        });
        this.search.addEventListener('input', () => this.filterBooks());
        this.dialog.addEventListener('close', () => { document.documentElement.classList.remove('bitig-bundle-open'); this.trigger?.focus(); });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.form.addEventListener('submit', (event) => this.addToCart(event));
        this.update();
      });
    }
    disconnectedCallback() { if (this.dialog?.open) document.documentElement.classList.remove('bitig-bundle-open'); }
    money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100); }
    update() {
      const selected = [...this.querySelectorAll('[data-bundle-check]:checked')].filter(item => !item.disabled);
      const regular = selected.reduce((sum,item) => sum + Number(item.dataset.price),0);
      const rate = selected.length >= 4 ? 20 : selected.length === 3 ? 15 : selected.length === 2 ? 10 : 0;
      const discount = Math.floor(regular * rate / 100);
      this.querySelector('[data-bundle-discount-label]').textContent = this.strings.discount.replace('{percent}', rate);
      this.querySelector('[data-bundle-regular]').textContent = this.money(regular);
      this.querySelector('[data-bundle-saving]').textContent = '−' + this.money(discount);
      this.querySelector('[data-bundle-total]').textContent = this.money(regular - discount);
      this.querySelector('[data-bundle-total-label]').textContent = discount ? this.strings.discounted : this.strings.total;
      this.querySelector('[data-bundle-regular-row]').hidden = !discount;
      this.querySelector('[data-bundle-saving-row]').hidden = !discount;
      this.querySelector('[data-bundle-hint]').hidden = !!discount;
      this.querySelector('[data-bundle-count]').textContent = selected.length;
      this.querySelector('.bitig-fbt__button').disabled = selected.length === 0 || !!this.busy;
    }
    async openPicker(trigger) {
      if (this.busy) return;
      this.trigger = trigger;
      this.activeCard = trigger.closest('.bitig-fbt__product');
      this.search.value = '';
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      document.documentElement.classList.add('bitig-bundle-open');
      this.search.focus();
      if (!this.catalogLoaded) await this.loadBooks();
      else this.filterBooks();
    }
    async loadBooks() {
      if (this.loading) return;
      this.loading = true;
      this.status.textContent = this.strings.loading;
      this.options.replaceChildren();
      this.querySelector('[data-bundle-retry]').hidden = true;
      this.search.disabled = true;
      try {
        let url = new URL(this.dataset.catalogUrl, location.origin);
        const visited = new Set();
        const fragment = document.createDocumentFragment();
        while (url) {
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalogue page');
          visited.add(url.href);
          const response = await fetch(url, {headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Catalogue unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const catalog = doc.querySelector('[data-bundle-catalog]');
          if (!catalog) throw new Error('Catalogue unavailable');
          catalog.querySelectorAll('[data-bundle-option]').forEach(option => fragment.append(document.importNode(option,true)));
          url = catalog.dataset.nextUrl ? new URL(catalog.dataset.nextUrl,location.origin) : null;
          if (url) url.searchParams.set('section_id','bitig-bundle-options');
        }
        this.options.append(fragment);
        this.catalogLoaded = true;
        this.filterBooks();
      } catch {
        this.status.textContent = this.strings.loadError;
        this.querySelector('[data-bundle-retry]').hidden = false;
      } finally { this.loading = false; this.search.disabled = false; }
    }
    filterBooks() {
      if (!this.catalogLoaded) return;
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();
      const words = normalize(this.search.value).trim().split(/\s+/).filter(Boolean);
      const used = new Set([...this.querySelectorAll('[data-bundle-check]')].map(check => check.dataset.productId));
      let count = 0;
      this.options.querySelectorAll('[data-bundle-option]').forEach(option => {
        const haystack = normalize(option.dataset.title + ' ' + option.dataset.author);
        option.hidden = !words.every(word => haystack.includes(word));
        option.disabled = used.has(option.dataset.productId);
        if (!option.hidden) count++;
      });
      this.status.textContent = count ? this.strings.results.replace('{count}',count) : this.strings.empty;
    }
    choose(option) {
      if (!this.activeCard || this.busy) return;
      const check = this.activeCard.querySelector('[data-bundle-check]');
      check.dataset.variantId = option.dataset.variantId;
      check.dataset.productId = option.dataset.productId;
      check.dataset.price = option.dataset.price;
      check.setAttribute('aria-label',option.dataset.title);
      check.disabled = false;
      check.checked = true;
      const title = this.activeCard.querySelector('.bitig-fbt__title');
      title.textContent = option.dataset.title;
      title.title = option.dataset.title;
      title.href = option.dataset.productUrl;
      this.activeCard.querySelector('.bitig-fbt__price').textContent = this.money(Number(option.dataset.price));
      const image = this.activeCard.querySelector('img');
      const replacement = option.querySelector('img').cloneNode(true);
      replacement.className = 'bitig-fbt__image';
      image.replaceWith(replacement);
      this.querySelector('[data-bundle-error]').hidden = true;
      this.update();
      this.dialog.close();
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      const checks = [...this.querySelectorAll('[data-bundle-check]:checked')].filter(check => !check.disabled);
      if (!checks.length) return;
      const items = checks.map(check => ({id:Number(check.dataset.variantId),quantity:1}));
      const button = this.querySelector('.bitig-fbt__button');
      const original = button.innerHTML;
      this.busy = true;
      button.disabled = true;
      button.textContent = this.strings.adding;
      const controls = [...this.form.querySelectorAll('input,button')].map(control=>[control,control.disabled]);
      controls.forEach(([control]) => control.disabled = true);
      this.querySelector('[data-bundle-error]').hidden = true;
      try {
        const response = await fetch(this.form.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error('Cart request failed');
        location.assign(this.form.dataset.cartUrl);
      } catch {
        this.busy = false;
        controls.forEach(([control,disabled]) => control.disabled = disabled);
        button.innerHTML = original;
        this.querySelector('[data-bundle-error]').hidden = false;
        this.update();
      }
    }
  });
}
